export { AppStorageService, KEYS_APPSTORAGE } from 'sce-core';
// #TODO-LIBRARY AppStorageService Used in 6 places 6 files in WMS /src/app.. should be re-referenced from library directly
